import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PersonalDetails } from "@/apps/partner/components/PersonalDetails/PersonalDetails";
import { AddDeviceFormType } from "@/apps/partner/types";
import { partnerAddDeviceStepPaths } from "@/apps/partner/utils/partnerAddDevice.constants";
import { transformFormDataToPrepareBasketRequest } from "@/apps/partner/utils/transformPrepareBasketRequest";
import { Button } from "@/components/Interface/Button/Button";
import { StepFlowNavigation } from "@/components/Layout/BaseLayouts/StepFlowLayout/StepFlowNavigation";
import { getHeader } from "@/components/Portal/DeviceManagement/Roaming/roamingUtils";
import { useHandleError } from "@/hooks/useHandleError";
import { prepareBasket } from "@/services/api";

export const PartnerPersonalDetailsStep = () => {
  const { t } = useTranslation("partnerPortal", { keyPrefix: "addDevice" });
  const { t: tCommon } = useTranslation();
  const navigate = useNavigate();
  const handleError = useHandleError();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { handleSubmit } = useFormContext<AddDeviceFormType>();

  const handleBack = () => {
    navigate(partnerAddDeviceStepPaths.quantity);
  };

  const onSubmit = async (data: AddDeviceFormType) => {
    setIsSubmitting(true);

    try {
      const header = getHeader();
      const payload = transformFormDataToPrepareBasketRequest(data, header);
      const quantity = data.quantity ?? 1;

      for (let i = 0; i < quantity; i++) {
        await prepareBasket(payload);
      }

      sessionStorage.setItem("orderSuccess", "true");
      sessionStorage.setItem(
        "orderSuccessCustomerType",
        data.isExistingCustomer ? "existing" : "new",
      );
      navigate("/partner/add-sim/success");
    } catch (error) {
      handleError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex w-full flex-col gap-6">
      <PersonalDetails />

      <StepFlowNavigation
        primaryButton={
          <Button
            dataTestid="submit-onboarding-button"
            variant="primary"
            disabled={isSubmitting}
            onClick={handleSubmit(onSubmit)}
          >
            {isSubmitting ? t("submitting") : t("submit")}
          </Button>
        }
        secondaryButton={
          <Button variant="secondary" onClick={handleBack}>
            {tCommon("Common.label.back")}
          </Button>
        }
      />
    </div>
  );
};
